export default __webpack_public_path__ + "static/media/1102.2ad485fa.png";